import { MapLocation } from '@/types/location';

// Wave Media — Mall network (dummy / hidden media owner)
export const waveMediaLocations: MapLocation[] = [
  // Riyadh
  {
    id: 9501,
    name: 'Riyadh Park Mall',
    type: 'Mall',
    devices: 24,
    coordinates: [24.7565, 46.6390],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-55',
    segment: 'Premium Shoppers',
    details: {
      screenDimensions: '2.0m x 1.13m',
      resolution: '4K UHD',
      description: 'Premium indoor LED network across food court & main concourse at Riyadh Park.',
    },
  },
  {
    id: 9502,
    name: 'Granada Center',
    type: 'Mall',
    devices: 18,
    coordinates: [24.7720, 46.7400],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Mixed',
    ageRange: '20-50',
    segment: 'Family Shoppers',
    details: {
      screenDimensions: '1.13m x 2.0m',
      resolution: '4K UHD',
      description: 'Vertical digital pillars throughout Granada Center walkways.',
    },
  },
  {
    id: 9503,
    name: 'Panorama Mall',
    type: 'Mall',
    devices: 16,
    coordinates: [24.6940, 46.6840],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-45',
    segment: 'Lifestyle Shoppers',
    details: {
      screenDimensions: '2.0m x 1.13m',
      resolution: '4K UHD',
      description: 'High-traffic LED screens near main entrances & cinema area.',
    },
  },
  {
    id: 9504,
    name: 'Hayat Mall',
    type: 'Mall',
    devices: 20,
    coordinates: [24.8095, 46.7240],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Mixed',
    ageRange: '20-55',
    segment: 'Family Shoppers',
    details: {
      screenDimensions: '1.13m x 2.0m',
      resolution: '4K UHD',
      description: 'Digital signage network across two floors of Hayat Mall.',
    },
  },
  {
    id: 9505,
    name: 'Nakheel Mall Riyadh',
    type: 'Mall',
    devices: 22,
    coordinates: [24.7610, 46.6710],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-50',
    segment: 'Premium Shoppers',
    details: {
      screenDimensions: '2.5m x 1.4m',
      resolution: '4K UHD',
      description: 'Flagship LED video walls at Nakheel Mall main atrium.',
    },
  },

  // Jeddah
  {
    id: 9506,
    name: 'Red Sea Mall',
    type: 'Mall',
    devices: 26,
    coordinates: [21.6480, 39.1240],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-55',
    segment: 'Premium Shoppers',
    details: {
      screenDimensions: '2.5m x 1.4m',
      resolution: '4K UHD',
      description: 'Network of premium LED screens across all levels of Red Sea Mall.',
    },
  },
  {
    id: 9507,
    name: 'Mall of Arabia Jeddah',
    type: 'Mall',
    devices: 28,
    coordinates: [21.5810, 39.1620],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-50',
    segment: 'Family Shoppers',
    details: {
      screenDimensions: '2.0m x 1.13m',
      resolution: '4K UHD',
      description: 'Mall-wide digital network including entertainment zone.',
    },
  },
  {
    id: 9508,
    name: 'Aziz Mall',
    type: 'Mall',
    devices: 14,
    coordinates: [21.5210, 39.1845],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Mixed',
    ageRange: '20-45',
    segment: 'Lifestyle Shoppers',
    details: {
      screenDimensions: '1.13m x 2.0m',
      resolution: '4K UHD',
      description: 'Portrait digital displays at retail corridors.',
    },
  },
  {
    id: 9509,
    name: 'Stars Avenue Mall',
    type: 'Mall',
    devices: 16,
    coordinates: [21.6045, 39.1075],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-45',
    segment: 'Premium Shoppers',
    details: {
      screenDimensions: '2.0m x 1.13m',
      resolution: '4K UHD',
      description: 'Premium digital network on Corniche Road.',
    },
  },
  {
    id: 9510,
    name: 'Salaam Mall',
    type: 'Mall',
    devices: 18,
    coordinates: [21.5460, 39.1720],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Mixed',
    ageRange: '20-55',
    segment: 'Family Shoppers',
    details: {
      screenDimensions: '1.13m x 2.0m',
      resolution: '4K UHD',
      description: 'Vertical screens across walkways and food court.',
    },
  },

  // Makkah
  {
    id: 9511,
    name: 'Makkah Mall',
    type: 'Mall',
    devices: 22,
    coordinates: [21.4380, 39.8945],
    region: 'Makkah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-55',
    segment: 'Pilgrims & Locals',
    details: {
      screenDimensions: '2.0m x 1.13m',
      resolution: '4K UHD',
      description: 'High-traffic LED screens at Makkah Mall serving pilgrims and residents.',
    },
  },
  {
    id: 9512,
    name: 'Al Diyafa Mall',
    type: 'Mall',
    devices: 14,
    coordinates: [21.4135, 39.8120],
    region: 'Makkah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Mixed',
    ageRange: '20-50',
    segment: 'Family Shoppers',
    details: {
      screenDimensions: '1.13m x 2.0m',
      resolution: '4K UHD',
      description: 'Portrait digital pillars at Al Diyafa Mall.',
    },
  },
  {
    id: 9513,
    name: 'Abraj Al Bait Mall',
    type: 'Mall',
    devices: 30,
    coordinates: [21.4192, 39.8260],
    region: 'Makkah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-65',
    segment: 'Pilgrims',
    details: {
      screenDimensions: '2.5m x 1.4m',
      resolution: '4K UHD',
      description: 'Flagship LED network at the Clock Tower complex.',
    },
  },
  {
    id: 9514,
    name: 'Al Andalus Mall Makkah',
    type: 'Mall',
    devices: 16,
    coordinates: [21.4480, 39.7980],
    region: 'Makkah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-50',
    segment: 'Lifestyle Shoppers',
    details: {
      screenDimensions: '2.0m x 1.13m',
      resolution: '4K UHD',
      description: 'Indoor LED network across main concourse.',
    },
  },
  {
    id: 9515,
    name: 'Nakheel Plaza Makkah',
    type: 'Mall',
    devices: 18,
    coordinates: [21.4015, 39.8460],
    region: 'Makkah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Indoor',
    screenType: 'Portrait Screens',
    orientation: 'Portrait',
    gender: 'Mixed',
    ageRange: '20-55',
    segment: 'Family Shoppers',
    details: {
      screenDimensions: '1.13m x 2.0m',
      resolution: '4K UHD',
      description: 'Vertical digital signage throughout Nakheel Plaza walkways.',
    },
  },

  // Outdoor billboards
  {
    id: 9516,
    name: 'King Fahd Road Billboard',
    type: 'Billboard',
    devices: 4,
    coordinates: [24.7136, 46.6753],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-65',
    segment: 'Commuters',
    details: {
      screenDimensions: '14m x 6m',
      resolution: '4K UHD',
      description: 'Premium outdoor LED billboard along King Fahd Road, peak commuter traffic.',
    },
  },
  {
    id: 9517,
    name: 'Olaya Street Digital Billboard',
    type: 'Billboard',
    devices: 3,
    coordinates: [24.6928, 46.6855],
    region: 'Riyadh',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-55',
    segment: 'Urban Commuters',
    details: {
      screenDimensions: '12m x 5m',
      resolution: '4K UHD',
      description: 'High-impact outdoor LED on Olaya Street business district.',
    },
  },
  {
    id: 9518,
    name: 'Corniche Road LED Wall',
    type: 'Billboard',
    devices: 5,
    coordinates: [21.6710, 39.1080],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-60',
    segment: 'Tourists & Locals',
    details: {
      screenDimensions: '16m x 7m',
      resolution: '4K UHD',
      description: 'Iconic seafront outdoor LED wall on Jeddah Corniche.',
    },
  },
  {
    id: 9519,
    name: 'Tahlia Street Mega Screen',
    type: 'Billboard',
    devices: 4,
    coordinates: [21.5433, 39.1728],
    region: 'Jeddah',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-50',
    segment: 'Lifestyle Shoppers',
    details: {
      screenDimensions: '12m x 6m',
      resolution: '4K UHD',
      description: 'Outdoor mega LED on Tahlia Street entertainment strip.',
    },
  },
  {
    id: 9520,
    name: 'Dhahran Highway Billboard',
    type: 'Billboard',
    devices: 3,
    coordinates: [26.2854, 50.1500],
    region: 'Eastern',
    mediaOwner: 'Wave Media',
    adminOnly: true,
    mediaKind: 'Outdoor',
    screenType: 'Landscape Screens',
    orientation: 'Landscape',
    gender: 'Mixed',
    ageRange: '18-65',
    segment: 'Commuters',
    details: {
      screenDimensions: '14m x 6m',
      resolution: '4K UHD',
      description: 'Strategic outdoor LED billboard on Dhahran-Khobar highway.',
    },
  },
];
